import { render, staticRenderFns } from "./LearnDataSources.vue?vue&type=template&id=3bf1cf46&scoped=true&"
import script from "./LearnDataSources.vue?vue&type=script&lang=js&"
export * from "./LearnDataSources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf1cf46",
  null
  
)

export default component.exports